import React, { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { AccountManager } from '@atlas/core';

import TerminalBasePopup from 'src/terminal/popups/TerminalBasePopup';

import { NotAuthorizedRedirect } from '../components/NotAuthorizedRedirect';

const StillHerePopup = () => {
  const { pathname } = useLocation();
  const { replace } = useHistory();
  const [counter, setCounter] = React.useState(59);

  const handleClose = useCallback(() => {
    replace(pathname);
  }, [pathname, replace]);

  const handleLogOut = useCallback(() => {
    AccountManager.logout();
    replace('/');
  }, [replace]);

  useEffect(() => {
    if (counter === 0) {
      handleLogOut();
    }

    const interval = setInterval(() => setCounter(counter => counter - 1), 1000);

    return () => clearInterval(interval);
  }, [counter, handleLogOut]);

  return (
    <>
      {counter > 10 && <NotAuthorizedRedirect to={pathname} />}
      <TerminalBasePopup
        buttonLabel="terminal_still_here_popup_yes_button"
        className="terminal-still-here-popup"
        icon="timer"
        onButtonClick={handleClose}
        onSecondaryButtonClick={handleLogOut}
        secondaryButtonLabel="terminal_still_here_popup_logout_button"
        text="terminal_still_here_popup_message"
        title="terminal_still_here_popup_title"
      >
        <span className="still-here-popup-counter">{counter}</span>
      </TerminalBasePopup>
    </>
  );
};

export default StillHerePopup;
